export default "__VITE_ASSET__4q1aoG1R__"